<template>
  <section class="section">
    <div class="is-title-bar">
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <h1 class="title">Enquetes</h1>
          </div>
          <!-- <h3 style="color: #888888" class="subtitle">{{ getClientName() }}</h3> -->
        </div>
        <div class="level-right" id="topTable">
          <div class="level-item">
            <b-button @click="dialog = true" icon-right="plus" type="is-primary"
              >Adicionar</b-button
            >
          </div>
        </div>
      </div>
    </div>
    <div class="card has-table">
      <!-- <v-toolbar flat color="white">
        <v-toolbar-title>Cadastro de Perguntas</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-dialog persistent v-model="dialog" max-width="500px">
          <b-button
            :disabled="!getRules.questions.edit"
            absolute
            dark
            fab
            top
            style="top: 10px; right: 10px"
            right
            color="primary"
            slot="activator"
          >
            <v-icon>add</v-icon>
          </b-button>

          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs9>
                    <v-text-field
                      v-model="editedItem.text"
                      label="Descrição"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs3>
                    <v-checkbox
                      v-model="editedItem.isActive"
                      label="Ativo"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex xs12>
                    <v-combobox
                      v-model="editedItem.answers"
                      label="Respostas"
                      chips
                      multiple
                      @input="wrapInObject"
                      return-object
                      hint="Digite a resposta e tecle ENTER"
                    >
                      <template slot="selection" slot-scope="data">
                        <v-chip
                          :selected="data.selected"
                          close
                          @input="removeResposta(data.item)"
                        >
                          <strong class="capitalize">{{
                            data.item.text
                          }}</strong>
                        </v-chip>
                      </template>
                    </v-combobox>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <b-button color="blue darken-1" flat @click.native="close"
                >Cancel</b-button
              >
              <b-button color="blue darken-1" flat @click.native="save"
                >Save</b-button
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar> -->

      <b-table
        :data="desserts"
        :paginated="true"
        :pagination-simple="true"
        :per-page="perPage"
        striped
      >
        <template slot-scope="props">
          <b-table-column field="text" label="Descrição" sortable>
            {{ props.row.text }}
          </b-table-column>
          <b-table-column field="isActive" label="Ativa" sortable>
            <b-icon
              :icon="props.row.isActive ? 'check-circle' : 'times-circle'"
              :type="props.row.isActive ? 'is-success' : 'is-danger'"
            ></b-icon>
          </b-table-column>
          <!--  <b-table-column field="isActive" label="NPS" sortable>
            <b-icon
              :icon="props.row.is_nps ? 'check-circle' : 'times-circle'"
              :type="props.row.is_nps ? 'is-success' : 'is-danger'"
            ></b-icon>
          </b-table-column> -->
          <!-- numeric para alinhar as acoes a direita-->
          <b-table-column numeric field="actions">
            <b-button
              icon-right="edit"
              size="is-small"
              type="is-light"
              @click="editItem(props.row, $event)"
              >Editar</b-button
            >
            <b-button
              icon-right="user-friends"
              size="is-small"
              type="is-primary"
              @click="getSummary(props.row)"
              >Resultado</b-button
            >
            <b-button
              icon-right="trash"
              size="is-small"
              type="is-danger"
              @click="deleteItem(props.row)"
              >Excluir</b-button
            >
          </b-table-column>
        </template>
        <template slot="empty">
          <section class="section">
            <div class="has-text-grey has-text-centered">
              <span>Sem perguntas para exibir</span>
            </div>
          </section>
        </template>
        <template slot="footer">
          <div class="level" style="padding-bottom: 0">
            <div class="level-left"></div>
            <div class="left-center"></div>
            <div class="level-right">
              <b-select v-model="perPage" size="is-small">
                <option value="10">10 por página</option>
                <option value="25">25 por página</option>
                <option value="50">50 por página</option>
                <option value="100">100 por página</option>
              </b-select>
            </div>
          </div>
        </template>
      </b-table>
      <b-modal has-modal-card trap-focus :active.sync="dialogUsers" can-cancel>
        <div class="modal-container">
          <div class="card" id="cardChart">
            <div class="card-header">
              <div class="card-header-title" v-if="questionSelected">
                {{ questionSelected.text }}
              </div>
            </div>

            <apex-chart-pie :questionData="dataByQuestion"></apex-chart-pie>

            <b-button
              id="buttonClose"
              label="Cancelar"
              type="is-light"
              size="is-small"
              @click="closeModal()"
            />

            <b-button
              id="buttonList"
              label="Listar"
              type="is-primary"
              size="is-small"
              @click="showList()"
            />
          </div>
        </div>
      </b-modal>
      <b-modal :active.sync="dialogList" :can-cancel="true">
        <div class="card">
          <div class="card-header">
            <div class="card-header-title" v-if="questionSelected">
              {{ questionSelected.text }}
            </div>
          </div>
          <user-question
            v-if="questionSelected"
            :question="questionSelected"
          ></user-question>
          <b-button
            id="buttonUser"
            label="Voltar"
            type="is-primary"
            size="is-small"
            @click="backUsers()"
          />
          <b-button
            id="buttonClose"
            label="Cancelar"
            type="is-light"
            size="is-small"
            @click="closeModal()"
          />
        </div>
      </b-modal>
    </div>

    <b-modal
      :active.sync="dialog"
      has-modal-card
      trap-focus
      :can-cancel="false"
      aria-role="dialog"
      aria-modal
    >
      <form action="">
        <div class="modal-card" id="questionModal">
          <header class="modal-card-head">
            <p class="modal-card-title">{{ formTitle }}</p>
          </header>
          <section class="modal-card-body">
            <b-field
              label="Descrição"
              label-position="on-border"
              type="is-primary"
            >
              <b-input type="text" v-model="editedItem.text" required>
              </b-input>
            </b-field>
            <div class="questioninfo">
              <b-field grouped group-multiline style="margin-top: 12px">
                <b-field
                  type="is-primary"
                  expanded
                  label="Tempo de Exibição"
                  label-position="on-border"
                >
                  <b-datepicker
                    id="datepicker"
                    v-model="dates"
                    range
                    :mobile-native="false"
                    :date-formatter="dateConverter"
                    @input="selectDate()"
                    icon="calendar-day"
                    style="width: 240px"
                    :min-date="today"
                    append-to-body
                  >
                  </b-datepicker>
                </b-field>
              </b-field>

              <b-field class="checkBoxQuestion">
                <b-checkbox type="is-primary" v-model="editedItem.isActive"
                  >Ativa</b-checkbox
                >
              </b-field>
            </div>
            <b-field
              id="textModal"
              label="Dias e horários de exibição"
              label-position="inside"
            ></b-field>
            <br />
            <b-field grouped group-multiline>
              <b-checkbox
                expanded
                v-for="(day, index) in weekdays"
                :key="day"
                v-model="editedItem.days"
                :native-value="index"
                type="is-primary"
                >{{ day }}</b-checkbox
              >
            </b-field>
            <b-field style="margin-top: 12px">
              <b-field
                id="textModal"
                label="Horários inicial e final"
                label-position="inside"
              ></b-field>
            </b-field>
            <br />

            <b-field grouped group-multiline id="hourSelector">
              <b-field type="is-primary">
                <b-select label="Início" v-model="startHour">
                  <option
                    v-for="option in hours"
                    :value="option"
                    :key="option"
                    >{{ option }}</option
                  >
                </b-select>
                <b-select placeholder="Fim" v-model="endHour">
                  <option
                    v-for="option in hours"
                    :value="option"
                    :key="option"
                    >{{ option }}</option
                  >
                </b-select>
                <b-button
                  type="is-primary"
                  icon-right="plus-circle"
                  @click="addHourRange(startHour, endHour)"
                ></b-button>
              </b-field>

              <b-field
                grouped
                group-multiline
                v-for="(tag, index) in hourRanges"
                :key="index"
              >
                <b-tag
                  size="is-medium"
                  type="is-primary"
                  closable
                  @close="removeHourRange(index)"
                  >{{ tag }}</b-tag
                >
              </b-field>
            </b-field>

            <!--  <b-field>
              <b-checkbox
                type="is-primary"
                v-model="editedItem.is_nps"
                :disabled="editedIndex > -1"
                >NPS</b-checkbox
              >
            </b-field> -->
            <!--
            <b-field>
              <b-checkbox type="is-primary" v-model="editedItem.is_nps"
                >Multi Respostas</b-checkbox
              >
            </b-field>
            -->

            <b-field
              v-if="!editedItem.is_nps"
              label="Respostas"
              label-position="on-border"
              type="is-primary"
            >
              <b-taginput
                v-model="editedItem.answers"
                type="is-primary"
                @add="wrapInObject"
                field="text"
                rounded
                icon="tag"
                placeholder="Digite a resposta e tecle ENTER"
              >
              </b-taginput>
            </b-field>
          </section>
          <footer class="modal-card-foot">
            <b-button @click="close" :loading="saving"> Cancelar </b-button>
            <b-button type="is-primary" @click.native="save" :loading="saving">
              Salvar
            </b-button>
            <!-- <b-button
              type="is-primary"
              @click.native="saveGrupo"
              :loading="saving"
              v-if="!editedItem.is_nps"
            >
              Salvar no Grupo
            </b-button> -->
          </footer>
        </div>
      </form>
    </b-modal>
  </section>
</template>

<script>
import Webservices from "@/Webservices";
import { mapActions, mapGetters } from "vuex";
import UserQuestion from "@/components/UserQuestion";
import store from "@/store";
import ApexChartPie from "@/components/charts/ApexChartPie";
var moment = require("moment");
const ws = new Webservices();

export default {
  components: {
    UserQuestion,
    ApexChartPie
  },
  data: () => ({
    is_nps: false,
    saving: false,
    perPage: 10,
    questionSelected: null,
    dialogUsers: false,
    dialogList: false,
    graphAux: false,
    questionData: {
      summary: [],
      text: []
    },
    dates: [],
    dialog: false,
    headers: [
      {
        label: "Descrição",
        align: "left",
        field: "text"
      },
      { label: "Ativa", field: "isActive" },
      { label: "Actions", align: "center", field: "name", sortable: false }
    ],
    desserts: [],
    desserts_nps: [],
    editedIndex: -1,

    editedItem: {
      text: "",
      answers: [],
      isActive: true,
      days: ["0", "1", "2", "3", "4", "5", "6"],
      hourRanges: {
        startHour: [],
        endHour: []
      },
      startDate: "",
      endDate: ""
    },
    defaultItem: {
      text: "",
      answers: [],
      isActive: true,
      days: ["0", "1", "2", "3", "4", "5", "6"],
      hourRanges: {
        startHour: [],
        endHour: []
      },
      startDate: "",
      endDate: ""
    },
    today: new Date(moment().subtract(1, "days")),
    question: {},
    hours: [
      "00:00",
      "01:00",
      "02:00",
      "03:00",
      "04:00",
      "05:00",
      "06:00",
      "07:00",
      "08:00",
      "09:00",
      "10:00",
      "11:00",
      "12:00",
      "13:00",
      "14:00",
      "15:00",
      "16:00",
      "17:00",
      "18:00",
      "19:00",
      "20:00",
      "21:00",
      "22:00",
      "23:00",
      "23:59"
    ],
    weekdays: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"],
    startHour: "00:00",
    endHour: "23:59",
    hourRanges: []
  }),
  computed: {
    ...mapGetters([
      "getClientID",
      "getControllerId",
      "getRules",
      "getID",
      "getGroupId",
      "getClients",
      "getToken",
      "getCompanyID"
    ]),
    formTitle() {
      return this.editedIndex === -1 ? "Nova Pergunta" : "Editar Pergunta";
    },
    dataByQuestion() {
      let output = this.questionData;

      return output;
    }
  },

  async mounted() {
    if (await ws.checkAccessToken(this.getToken)) {
      this.logout();
      this.$router.push("/login");
    }

    ws.setToken(this.getToken);
    if (this.getID) {
      ws.getQuestions(this.getcompanyID)
        .then(response => {
          var clientID = '"' + this.getID + '"';
          var questionClient = [];

          if (response) {
            response.data.forEach(el => {
              if (el.question.clientID.localeCompare(clientID) == 0) {
                questionClient.push(el);
              }

              if (el.question.clientID.localeCompare(this.getID) == 0) {
                questionClient.push(el);
              }
            });
          }

          this.desserts = [];
          questionClient.forEach(el => {
            this.desserts.push({
              category: el.question.category,
              clientID: el.question.clientID,
              createdDate: el.question.createdDate,
              id: el.question.id,
              isActive: el.question.isActive,
              lastDisabled: el.question.lastDisabled,
              text: el.question.text,
              answers: el.answers,
              days: el.question.days,
              hourRanges: el.question.hourRanges,
              startDate: el.question.startDate,
              endDate: el.question.endDate
            });
          });

          // if (store.state.client) {
          //   ws.getQuestionsNpsByControllerId(store.state.client.controller_id)
          //     .catch(error => {
          //       console.log("error: " + error);
          //     })
          //     .then(response_nps => {
          //       if (response_nps){
          //         for (let response of response_nps.data) {
          //         response.is_nps = true;
          //         this.desserts.push(response);
          //       }
          //       }
          //     });
          // }
        });
    } else {
      ws.getQuestionsByGroup(this.getGroupId).then(response => {
        response.data.forEach(question => {
          if (
            !this.desserts.find(
              el => el.question_group_id == question.question_group_id
            )
          )
            this.desserts.push(question);
        });
      });
    }
  },

  watch: {
    dialogUsers(val) {
      if (val) {
        store.state.currentModal = "resultQuestionModal";
      } else {
        store.state.currentModal = undefined;
      }
    },
    dialog(val) {
      if (val) {
        store.state.currentModal = "addOrEditQuestionModal";
      } else {
        store.state.currentModal = undefined;
        this.close();
      }
    },
    getControllerId(newValue, oldValue) {
      this.desserts = [];

      this.questionData.summary = [];
      this.questionData.text = [];
      ws.getQuestions(newValue)
        .catch(response => {
          console.log("error: " + error);
        })
        .then(response => {
          var clientID = '"' + this.getID + '"';
          var questionClient = [];

          if (response) {
            response.data.forEach(el => {
              if (el.question.clientID.localeCompare(clientID) == 0) {
                questionClient.push(el);
              }

              if (el.question.clientID.localeCompare(this.getID) == 0) {
                questionClient.push(el);
              }
            });
          }

          this.desserts = [];
          questionClient.forEach(el => {
            this.desserts.push({
              category: el.question.category,
              clientID: el.question.clientID,
              createdDate: el.question.createdDate,
              id: el.question.id,
              isActive: el.question.isActive,
              lastDisabled: el.question.lastDisabled,
              text: el.question.text,
              answers: el.answers,
              startDate: el.startDate,
              endDate: el.endDate
            });
          });
        });
    }
  },

  created() {
    this.initialize();
  },

  methods: {
    ...mapActions(["logout"]),
    initialize() {},
    getClientName() {
      return store.state.client ? store.state.client.name : "";
    },

    dateConverter(date) {
      if (date[0]) {
        return (
          date[0].toLocaleString("pt-BR", {
            year: "numeric",
            month: "numeric",
            day: "numeric",
            timeZone: "UTC"
          }) +
          " - " +
          date[1].toLocaleString("pt-BR", {
            year: "numeric",
            month: "numeric",
            day: "numeric",
            timeZone: "UTC"
          })
        );
      }
    },
    showList() {
      this.dialogUsers = false;
      this.dialogList = true;
    },
    backUsers(item) {
      this.dialogUsers = true;
      this.dialogList = false;
    },
    closeModal() {
      this.dialogUsers = false;
      this.dialogList = false;
    },
    addHourRange(startHour, endHour) {
      this.hourRanges.push(`${startHour} - ${endHour}`);
      this.editedItem.hourRanges.startHour.push(startHour);
      this.editedItem.hourRanges.endHour.push(endHour);
    },
    removeHourRange(index) {
      this.editedItem.hourRanges.startHour.splice(index, 1);
      this.editedItem.hourRanges.endHour.splice(index, 1);
      this.hourRanges.splice(index, 1);
    },
    editItem(item, event) {
      event.stopPropagation();

      if (item.startDate != null && item.endDate != null) {
        this.dates[0] = new Date(item.startDate);
        this.dates[1] = new Date(item.endDate);
      }

      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);

      if (!this.editedItem.hourRanges) {
        this.editedItem["hourRanges"] = {
          startHour: [],
          endHour: []
        };
        this.editedItem.hourRanges.startHour.push("00:00");
        this.editedItem.hourRanges.endHour.push("23:59");
        this.hourRanges[0] = "00:00 - 23:59";
      } else {
        this.editedItem.hourRanges.startHour.forEach((el, index) => {
          this.hourRanges[
            index
          ] = `${this.editedItem.hourRanges.startHour[index]} - ${this.editedItem.hourRanges.endHour[index]}`;
        });
      }
      if (!this.editedItem.days) {
        this.editedItem["days"] = ["0", "1", "2", "3", "4", "5", "6"];
      }
      this.dialog = true;
    },

    deleteItem(item) {
      const index = this.desserts.indexOf(item);
      if (confirm("Você tem certeza que deseja remover essa pergunta?")) {
        this.desserts.splice(index, 1);
        if (item.is_nps) {
          ws.deleteQuestionsNpsByControllerId(item.id);
        } else {
          ws.deleteQuestion(item);
        }
      }
    },
    selectDate() {
      this.editedItem["startDate"] = new Date(this.dates[0]);
      this.editedItem["endDate"] = new Date(this.dates[1]);
    },
    close() {
      this.startHour = "00:00";
      this.endHour = "23:59";
      this.dates = [];
      this.editedItem.days = ["0", "1", "2", "3", "4", "5", "6"];
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (!this.editedItem.hourRanges.startHour[0]) {
        this.editedItem.hourRanges.startHour[0] = "00:00";
        this.editedItem.hourRanges.endHour[0] = "23:59";
      }
      if (
        this.editedItem.startDate &&
        this.editedItem.endDate &&
        this.editedItem.text &&
        this.editedItem.answers
      ) {
        this.editedItem["clientID"] = this.getID;
        this.editedItem["category"] = "Multiple";
        this.editedItem["createdDate"] = new Date();

        if (this.editedIndex > -1) {
          if (this.editedItem.is_nps) {
            ws.updateQuestionsNpsByControllerId(
              this.editedItem
            ).then(response => {});
          } else {
            ws.updateQuestion(this.editedItem).then(response => {});
          }
          /*
        Object.assign(this.desserts[this.editedIndex], this.editedItem);

        */
        } else {
          this.desserts.push(this.editedItem);
          if (this.editedItem.is_nps) {
            ws.postQuestionsNpsByControllerId(
              this.editedItem
            ).then(response => {});
          } else {
            console.log(this.editedItem);
            ws.saveQuestion(this.editedItem).then(response => {});
          }
          /*

        */
        }
        this.close();
      } else {
        alert("Preencha os todos os campos");
      }
    },
    async saveGrupo() {
      this.saving = true;

      this.editedItem["group_id"] = this.getGroupId;

      if (!!this.editedItem["question_group_id"]) {
        var response = await ws.updateQuestionGroup(this.editedItem);
      } else {
        var questionGroupId = `${this.getGroupId}_${new Date().toISOString()}`;

        for (var i = 0; i < this.getClients.length; i++) {
          const el = this.getClients[i];

          var item = Object.assign({}, this.editedItem);

          item["client_id"] = el.controller_id;
          item["company_id"] = el.controller_id;
          item["question_group_id"] = questionGroupId;

          var response = await ws.saveQuestion(item);

          if (!this.getID && i == 0) this.desserts.push(response.data);
          else if (response.data.client_id == this.getControllerId)
            this.desserts.push(response.data);
        }
      }

      this.saving = false;

      this.close();
    },
    // formTitle() {
    //   return this.editedIndex === -1 ? "Nova Pergunta" : "Editar Pergunta";
    // },
    wrapInObject() {
      var array = this.editedItem.answers;
      console.log(array);
      array.sort((a, b) => {
        var saida = 0;
        if (!a.hasOwnProperty("id")) saida = 1;
        else if (!b.hasOwnProperty("id")) saida = -1;
        else saida = a.id > b.id ? -1 : 1;

        return saida;
      });

      var lastElement = array[0];

      var newIndex = (lastElement.id || 0) + 1;
      var value = array[array.length - 1];
      array.splice(-1, 1, { id: newIndex, text: value });

      array.sort((a, b) => (a.id > b.id ? 1 : -1));
    },

    getSummary(item) {
      this.dialogList = false;

      ws.getSummaryQuestion(item.id).then(response => {
        let totalSum = {};

        response.data.forEach(el => {
          let sum = 0;
          el.ageRanges.forEach(element => {
            element.forEach(num => {
              if (!isNaN(num)) sum += num;
            });
          });
          totalSum[el.answerID]
            ? (totalSum[el.answerID] += sum)
            : (totalSum[el.answerID] = sum);
        });
        let aux = 0;
        Object.keys(totalSum).forEach(key => {
          this.questionData.summary[aux] = totalSum[key];
          aux++;
        });

        for (let aux = 0; aux < this.desserts[0].answers.length; aux++) {
          this.questionData.text[aux] = this.desserts[0].answers[aux].text;
        }
        this.questionSelected = item;
        this.dialogUsers = true;
      });
    }
  }
};
</script>

<style scoped>
.capitalize {
  text-transform: capitalize !important;
}
.modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}
#cardChart {
  display: flex;
  justify-content: center;
  align-self: center;
  flex-direction: column;
  width: 100%;
}

#buttonList {
  font-size: 15px;
  right: 0;
  bottom: 0;
  position: absolute;
  margin: 10px;
  margin-right: 20px;
}

#buttonUser {
  font-size: 15px;
  left: 0;
  bottom: 0;
  position: absolute;
  margin: 10px;
  margin-left: 120px;
}

#buttonClose {
  font-size: 15px;
  left: 0;
  bottom: 0;
  position: absolute;
  margin: 10px;
  margin-left: 18px;
}
.questioninfo {
  display: flex;
  flex-direction: row;
  padding-bottom: 20px;
}
.checkBoxQuestion {
  margin-top: 20px;
  padding-left: 20px;
}
#topTable {
  padding-bottom: 10px;
}
#hourSelector {
  padding-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Perguntas.vue